import React from "react";

import { Checkbox } from "@cayuse/shared-react.components.form.checkbox";
import PropTypes from "prop-types";

import styles from "./styles.css";

const FilterGroup = ({ label, options, selectedValues, onChange }) => {
	const handleChange = e => {
		const value = e.target.value;
		let newValues = [ ...selectedValues ];

		if (newValues.includes(value)) {
			newValues = newValues.filter(item => item !== value);
		} else {
			newValues.push(value);
		}
		onChange(newValues);
	};

	return (
		<div role="group" aria-labelledby={`group_${label.toLowerCase()}`} className={styles.sidebarFilter}>
			<label id={`group_${label.toLowerCase()}`} className={styles.filterTitle}>
				{label}
			</label>
			{options.map(option => (
				<Checkbox
					data-testid={`checkbox_filter_${option.value.toLowerCase()}`}
					key={option.value}
					label={option.label}
					checked={selectedValues.includes(option.value)}
					value={option.value}
					onChange={handleChange}
				/>
			))}
		</div>
	);
};

FilterGroup.propTypes = {
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
	})).isRequired,
	selectedValues: PropTypes.arrayOf(PropTypes.string),
	onChange: PropTypes.func.isRequired,
};

export default FilterGroup;
